import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { API_ENDPOINTS } from '../../config/apiConfig';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import { Link } from 'react-router-dom';

function ResetPassword() {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [status, setStatus] = useState('');
    const [formSubmitting, setFormSubmitting] = useState(false);

    const { token } = useParams();
    console.log(token);

    // Animation hook for form entry
    const [formRef, isFormVisible] = useScrollAnimation({ threshold: 0.3 });

    const handleResetPassword = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setStatus('Passwords do not match');
            return;
        }
        
        setFormSubmitting(true);
        console.log(password);

        try {
            const response = await axios.post(API_ENDPOINTS.resetPassword, {
                old_password: password,
                new_password: confirmPassword,
                token: token
            });
            console.log(response);
            setStatus('Password reset successful');
        } catch (error) {
            console.log(error);
            setStatus('Password reset failed');
        } finally {
            setFormSubmitting(false);
        }
    }

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col relative">
            {/* Logo in top left corner */}
            <div className={`absolute top-6 left-6 z-10 transition-all duration-1000 ease-out transform ${
                isFormVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}>
                <Link to="/">
                    <img src="/img/logo.png" alt="AmpTrans Logo" className="w-auto h-12" />
                </Link>
            </div>
            
            {/* Main content container - centered */}
            <div className="flex-1 flex items-center justify-center px-4 py-20">
                <div
                    ref={formRef}
                    className={`w-full max-w-2xl transition-all duration-1000 ease-out transform ${
                        isFormVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                    }`}
                >
                    <div className="w-full flex justify-center items-center p-8">
                        <div className="w-full bg-white rounded-lg p-8 shadow-lg">
                            {/* Header - Centered */}
                            <div className="text-center mb-8">
                                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-2 font-nunito">Reset Your Password</h2>
                                <p className="text-sm sm:text-base text-gray-600 font-nunito">Enter your new password below</p>
                            </div>
                            
                            <form onSubmit={handleResetPassword} className="space-y-6">
                                {/* New Password Input */}
                                <div className="text-center">
                                    <label htmlFor="password" className="block mb-2 text-gray-800 font-nunito font-medium text-sm text-left">
                                        New Password
                                    </label>
                                    <input 
                                        type="password" 
                                        className="w-full px-4 py-3 rounded-lg bg-gray-100 border-none font-nunito focus:outline-none focus:ring-2 focus:ring-primary transition-all duration-200 text-center" 
                                        id="password" 
                                        onChange={(e) => setPassword(e.target.value)} 
                                        required
                                        disabled={formSubmitting}
                                    />
                                </div>
                                
                                {/* Confirm Password Input */}
                                <div className="text-center">
                                    <label htmlFor="confirm-password" className="block mb-2 text-gray-800 font-nunito font-medium text-sm text-left">
                                        Confirm Password
                                    </label>
                                    <input 
                                        type="password" 
                                        className="w-full px-4 py-3 rounded-lg bg-gray-100 border-none font-nunito focus:outline-none focus:ring-2 focus:ring-primary transition-all duration-200 text-center" 
                                        id="confirm-password" 
                                        onChange={(e) => setConfirmPassword(e.target.value)} 
                                        required
                                        disabled={formSubmitting}
                                    />
                                </div>
                                
                                {/* Submit Button - Centered */}
                                <div className="flex justify-center">
                                    <button 
                                        type="submit" 
                                        className="w-full font-nunito uppercase text-white bg-gradient-to-r from-primary to-primary-light py-3 px-8 tracking-wider text-sm font-medium rounded-lg border-0 transition-all duration-500 hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                                        disabled={formSubmitting}
                                    >
                                        {formSubmitting ? (
                                            <>
                                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                                Resetting...
                                            </>
                                        ) : (
                                            'Reset Password'
                                        )}
                                    </button>
                                </div>
                            </form>
                            
                            {/* Status Message - Centered */}
                            {status && (
                                <div className="text-center mt-4">
                                    <p className={`text-sm font-nunito ${
                                        status === 'Password reset successful' 
                                            ? 'text-green-600' 
                                            : 'text-red-600'
                                    }`}>
                                        {status}
                                    </p>
                                </div>
                            )}
                            
                            {/* Back to Login - Centered */}
                            <div className="text-center mt-6 pt-4 border-t border-gray-200">
                                <Link 
                                    to="/login" 
                                    className="font-nunito bg-transparent border-none text-blue-500 underline cursor-pointer text-sm hover:text-blue-600 transition-colors duration-200"
                                >
                                    Back to login
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ResetPassword;